import { defineComponent as _defineComponent } from 'vue';
import Card from 'primevue/card';
import WeatherStationBadge from '../WeatherStation/WeatherStationBadge.vue';
import LotGraphs from '../LotGraphs.vue';
import Button from 'primevue/button';
import { computed } from 'vue';
import { useMitt } from '../../../Plugins/mitt';
import { FormPanel } from '../../../@types/Enums';
import { trans, transChoice } from 'laravel-vue-i18n';
import { formatISODate } from '../../../Services/Utils';
import { DateTime } from 'luxon';
import { Inertia } from '@inertiajs/inertia';
export default /*#__PURE__*/ _defineComponent({
    __name: 'Dashboard',
    props: {
        orchard: {
            type: Object,
            required: true,
        },
        irrigations: {
            type: Array,
            default: [],
        },
        fertilizations: {
            type: Array,
            default: [],
        },
    },
    setup(__props, { expose }) {
        expose();
        const props = __props;
        const emitter = useMitt();
        const mapCenter = { lat: props.orchard.latitude, lng: props.orchard.longitude };
        const edit = () => {
            emitter.emit('open-form-panel-enum', {
                form: FormPanel.OrchardDetailsForm,
                data: props.orchard,
            });
        };
        const getLastItem = (items) => items
            .filter((irrigation) => DateTime.fromISO(irrigation.date) <= DateTime.now())
            .pop();
        const getNextItem = (items) => items
            .filter((irrigation) => DateTime.fromISO(irrigation.date) > DateTime.now())
            .pop();
        const totalIrrigationsDone = computed(() => props.irrigations.filter((irrigation) => DateTime.fromISO(irrigation.date) <= DateTime.now()).length);
        const totalIrrigationsVolume = computed(() => props.irrigations.reduce((acc, irrigation) => acc + irrigation.volume, 0));
        const lastIrrigation = getLastItem(props.irrigations);
        const nextIrrigation = getNextItem(props.irrigations);
        const totalFertilizationsDone = computed(() => props.fertilizations.filter((fertilization) => DateTime.fromISO(fertilization.date) <= DateTime.now()).length);
        const lastFertilization = getLastItem(props.fertilizations);
        const nextFertilization = getNextItem(props.fertilizations);
        const reloadData = () => Inertia.reload({ only: ['orchard', 'irrigations'] });
        emitter.on('irrigation-saved', (data) => reloadData());
        emitter.on('fertilization-saved', (data) => reloadData());
        const openIrrigationDetails = (irrigation) => emitter.emit('open-irrigation-details', irrigation);
        const openFertilizationDetails = (fertilization) => emitter.emit('open-fertilization-details', fertilization);
        const __returned__ = { emitter, props, mapCenter, edit, getLastItem, getNextItem, totalIrrigationsDone, totalIrrigationsVolume, lastIrrigation, nextIrrigation, totalFertilizationsDone, lastFertilization, nextFertilization, reloadData, openIrrigationDetails, openFertilizationDetails, get Card() { return Card; }, WeatherStationBadge, get Button() { return Button; }, get trans() { return trans; }, get transChoice() { return transChoice; }, get formatISODate() { return formatISODate; } };
        Object.defineProperty(__returned__, '__isScriptSetup', { enumerable: false, value: true });
        return __returned__;
    }
});
